var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-agree",class:[
    _vm.disabled ? 'disabled' : ''
  ]},[_c('div',{staticClass:"md-agree-icon",class:[
      _vm.value ? 'checked' : ''
    ],on:{"click":function($event){return _vm.$_onChange($event)}}},[_c('div',{staticClass:"md-agree-icon-container"},[_c('md-icon',{attrs:{"name":"checked","size":_vm.size}}),_c('md-icon',{attrs:{"name":"check","size":_vm.size}})],1)]),_c('div',{staticClass:"md-agree-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }